import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import login_bg from '../assets/login_bg.jpg';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, CDN_URL, formatDate, formatMoney, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdArrowCircleLeft, MdArrowCircleRight, MdCircle, MdLock, MdLogin, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import { STR_AT_LEAST_ONE_IMAGE, STR_AVAILABLE_QUANTITY, STR_CANCELLATION_REASON, STR_CATEGORY, STR_CROPS, STR_DATE, STR_DELIVERY_LOCATION, STR_DISTRICT, STR_FULLY_PAID, STR_IMAGES, STR_INVALID_LOCATION, STR_INVALID_QUANTITY, STR_INVALID_TITLE, STR_INVALID_UNIT_PRICE, STR_IS_CANCELLED, STR_IS_CONFIRMED, STR_IS_DELIVERED, STR_IS_SHIPPED, STR_ITEM_DESCRIPTION, STR_ITEM_LOCATION, STR_ITEM_TITLE, STR_LIVESTOCK, STR_MOQ, STR_NO, STR_ORDER_NOTES, STR_ORDER_PAYMENTS, STR_ORDER_QUANTITY, STR_ORDERED_ITEM, STR_ORDERED_QUANTITY, STR_OUTSTANDING_BALANCE, STR_OVERALL_COST, STR_PARTIALLY_PAID, STR_PAYMENT_STATUS, STR_POST_ITEM, STR_REGION, STR_STREET, STR_SUBMIT, STR_SUCCESS, STR_TOTAL_PAID, STR_UNIT, STR_UNIT_PRICE, STR_UNPAID, STR_WARD, STR_YES } from "../Strings";


export default function OrderInfo({ data, paymentsProfile }) {

	const appContext = useContext(AppContext);

	const [loading, setLoading] = useState(false);
	
	const [deliveryLocation, setDeliveryLocation] = useState({});
	const [itemLocation, setItemLocation] = useState({});

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
		
		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	useEffect(() => {
		if(data) {
			setDeliveryLocation(JSON.parse(data.deliveryLocation));
			setItemLocation(JSON.parse(data.itemLocation));
		}
	}, [ data ])

	
	return (
		<div
			className="row"
		>
			
			<div className="col-12 mt-2 mb-2">
				<label className="form-label text-secondary">{STR_ORDERED_ITEM[appContext.language]}</label>
				<h6
					style={{
						fontSize: "24px",
					}}
				>
					{data.itemTitle}
				</h6>
			</div>

			<div className="col-6 col-md-4 mt-2 mb-2">
				<label className="form-label text-secondary">{STR_ORDERED_QUANTITY[appContext.language]}</label>
				<h6
					style={{
						fontSize: "18px",
					}}
				>
					{data.itemQuantity}
				</h6>
			</div>

			<div className="col-6 col-md-4 mt-2 mb-2">
				<label className="form-label text-secondary">{STR_UNIT[appContext.language]}</label>
				<h6
					style={{
						fontSize: "18px",
					}}
				>
					{data.itemUnit}
				</h6>
			</div>

			<div className="col-6 col-md-4 mt-2 mb-2">
				<label className="form-label text-secondary">{STR_DATE[appContext.language]}</label>
				<h6
					style={{
						fontSize: "14px",
					}}
				>
					{formatDate(data.dateCreated)}
				</h6>
			</div>

			<div className="col-6 col-md-4 mt-2 mb-2">
				<label className="form-label text-secondary">{STR_UNIT_PRICE[appContext.language]}</label>
				<h6
					style={{
						fontSize: "14px",
					}}
					className="font-bold"
				>
					{formatMoney(data.itemUnitPrice)} TZS / {data.itemUnit}
				</h6>
			</div>

			<div className="col-6 col-md-4 mt-2 mb-2">
				<label className="form-label text-secondary">{STR_PAYMENT_STATUS[appContext.language]}</label>
				<h6
					style={{
						fontSize: "14px",
					}}
					className="font-bold"
				>
					{data.paymentStatus === 'unpaid' ? STR_UNPAID[appContext.language] : ""}
					{data.paymentStatus === 'fully_paid' ? STR_FULLY_PAID[appContext.language] : ""}
					{data.paymentStatus === 'partially_paid' ? STR_PARTIALLY_PAID[appContext.language] : ""}
				</h6>
			</div>

			

			<div className="col-6 col-md-4 mt-2 mb-2">
				<label className="form-label text-secondary">{STR_IS_CONFIRMED[appContext.language]}</label>
				<h6
					style={{
						fontSize: "14px",
					}}
					className="font-bold"
				>
					{data.isConfirmed === 'yes' ? STR_YES[appContext.language] : ""}
					{data.isConfirmed === 'no' ? STR_NO[appContext.language] : ""}
				</h6>
			</div>

			<div className="col-6 col-md-4 mt-2 mb-2">
				<label className="form-label text-secondary">{STR_IS_CANCELLED[appContext.language]}</label>
				<h6
					style={{
						fontSize: "14px",
					}}
					className="font-bold"
				>
					{data.isCancelled === 'yes' ? STR_YES[appContext.language] : ""}
					{data.isCancelled === 'no' ? STR_NO[appContext.language] : ""}
				</h6>
			</div>

			<div className="col-6 col-md-4 mt-2 mb-2">
				<label className="form-label text-secondary">{STR_IS_SHIPPED[appContext.language]}</label>
				<h6
					style={{
						fontSize: "14px",
					}}
					className="font-bold"
				>
					{data.isShipped === 'yes' ? STR_YES[appContext.language] : ""}
					{data.isShipped === 'no' ? STR_NO[appContext.language] : ""}
				</h6>
			</div>

			<div className="col-6 col-md-4 mt-2 mb-2">
				<label className="form-label text-secondary">{STR_IS_DELIVERED[appContext.language]}</label>
				<h6
					style={{
						fontSize: "14px",
					}}
					className="font-bold"
				>
					{data.isDelivered === 'yes' ? STR_YES[appContext.language] : ""}
					{data.isDelivered === 'no' ? STR_NO[appContext.language] : ""}
				</h6>
			</div>

			{
				(data.isCancelled === 'yes') ?
				<div className="col-12 col-md-12 mt-2 mb-2">
					<label className="form-label text-secondary">{STR_CANCELLATION_REASON[appContext.language]}</label>
					<h6
						style={{
							fontSize: "14px",
						}}
						className="font-bold"
					>
						{data.cancellationReason || 'N/A'}
					</h6>
				</div>
				:""
			}

			<div className="col-12">
				<hr/>
			</div>

			<div className="col-6 mt-2 mb-2">
				<label className="form-label text-secondary">{STR_DELIVERY_LOCATION[appContext.language]}</label>
				<h6
					style={{
						fontSize: "12px",
					}}
				>
					<span className="font-bold text-muted">{STR_REGION[appContext.language]}:</span> <span className="font-bold">{deliveryLocation.region}</span>
					<br/>
					<span className="font-bold text-muted">{STR_DISTRICT[appContext.language]}:</span> <span className="font-bold">{deliveryLocation.district}</span>
					<br/>
					<span className="font-bold text-muted">{STR_WARD[appContext.language]}:</span> <span className="font-bold">{deliveryLocation.ward}</span>
					<br/>
					<span className="font-bold text-muted">{STR_STREET[appContext.language]}:</span> <span className="font-bold">{deliveryLocation.street}</span>
					<br/>
				</h6>
			</div>

			<div className="col-6 mt-2 mb-2">
				<label className="form-label text-secondary">{STR_ITEM_LOCATION[appContext.language]}</label>
				<h6
					style={{
						fontSize: "12px",
					}}
				>
					<span className="font-bold text-muted">{STR_REGION[appContext.language]}:</span> <span className="font-bold">{itemLocation.region}</span>
					<br/>
					<span className="font-bold text-muted">{STR_DISTRICT[appContext.language]}:</span> <span className="font-bold">{itemLocation.district}</span>
					<br/>
					<span className="font-bold text-muted">{STR_WARD[appContext.language]}:</span> <span className="font-bold">{itemLocation.ward}</span>
					<br/>
					<span className="font-bold text-muted">{STR_STREET[appContext.language]}:</span> <span className="font-bold">{itemLocation.street}</span>
					<br/>
				</h6>
			</div>

			{
				(
					data.isConfirmed === 'yes' &&
					data.isCancelled === 'no'
				) ?
				<>
					<div className="col-12">
						<hr/>
					</div>

					<div className="col-12">
						<h6
							className="font-bold text-secondary"
							style={{
								fontSize: "18px"
							}}
						>
							{STR_ORDER_PAYMENTS[appContext.language]}
						</h6>
					</div>
					<div className="col-6">
						<div
							style={{
								border: "2px solid var(--primaryColor)",
								borderRadius: "5px",
								padding: "5px"
							}}
						>
							<h6
								style={{
									fontSize: "18px"
								}}
								className="font-bold"
							>
								{formatMoney(data.overallCost)}
							</h6>
							<h6
								style={{
									fontSize: "12px"
								}}
								className="font-semi-bold text-muted"
							>
								{STR_OVERALL_COST[appContext.language]} (TZS)
							</h6>
						</div>
					</div>

					<div className="col-6">
						<div
							style={{
								border: "2px solid var(--secondaryColor)",
								borderRadius: "5px",
								padding: "5px"
							}}
						>
							<h6
								style={{
									fontSize: "18px"
								}}
								className="font-bold"
							>
								{formatMoney(paymentsProfile.totalPaid)}
							</h6>
							<h6
								style={{
									fontSize: "12px"
								}}
								className="font-semi-bold text-muted"
							>
								{STR_TOTAL_PAID[appContext.language]} (TZS)
							</h6>
						</div>
					</div>

					<div className="col-12 mt-3 mb-2">
						<div
							style={{
								border: "2px solid var(--primaryColor)",
								borderRadius: "5px",
								padding: "5px"
							}}
						>
							<h6
								style={{
									fontSize: "18px"
								}}
								className="font-bold"
							>
								{formatMoney(data.overallCost - paymentsProfile.totalPaid)}
							</h6>
							<h6
								style={{
									fontSize: "12px"
								}}
								className="font-semi-bold text-muted"
							>
								{STR_OUTSTANDING_BALANCE[appContext.language]} (TZS)
							</h6>
						</div>
					</div>
					
				</>
				:""
			}

		</div>
	)
	
}